export default {
  apiUrl: '/api/get_order_limits',
  trackBy: 'wine_id',
  dataPath: 'result',
  paginationPath: 'data',
  onEachSide: 1,
  preloadList: [
  ],
  sortOrder: [{
    field: 'wine_id',
    sortField: 'wine_id',
    direction: 'DESC',
  }],
  // paginationTemplate: {
  //   class: '',
  //   template: '총 {total}개 중의 {from} 부터 {to}',
  // },
  fields: [
    // {
    //   name: '__checkbox',
    //   titleClass: 'text-center',
    //   dataClass: 'text-center',
    // },
    {
      name: 'wine_id',
      title: '<i style="white-space: nowrap">와인 아이디</i>',
      sortField: 'wine_id',
      titleClass: 'text-center',
      dataClass: 'text-right',
      callback: 'subStringField',
    },
    {
      name: 'wine_name',
      title: '<i style="white-space: nowrap">와인 명</i>',
      sortField: 'wine_name',
      titleClass: 'text-center',
      dataClass: 'text-right',
      callback: 'subStringField',
    },
    {
      name: 'vintage',
      title: '<i style="white-space: nowrap">빈티지</i>',
      sortField: 'vintage',
      titleClass: 'text-center',
      dataClass: 'text-right',
      callback: 'subStringField',
    },
    {
      name: 'limit_per_order',
      title: '<i style="white-space: nowrap">주문당 구매제한</i>',
      sortField: 'limit_per_order',
      titleClass: 'text-center',
      dataClass: 'text-right',
    },
    {
      name: 'inventory_count',
      title: '<i style="white-space: nowrap">재고</i>',
      sortField: 'inventory_count',
      titleClass: 'text-center',
      dataClass: 'text-right',
    },
    {
      name: 'sold_out_limit',
      title: '<i style="white-space: nowrap">품절기준</i>',
      sortField: 'sold_out_limit',
      titleClass: 'text-center',
      dataClass: 'text-right',
    },
  ],
};



// WEBPACK FOOTER //
// ./src/spa/components/board/wine/limits/Config.js